<p-table
  [loading]="loading"
  [value]="technicalDocumentTypes"
  [paginator]="true"
  [rows]="10"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  responsiveLayout="stack"
  [breakpoint]="'600px'"
>
  <ng-template pTemplate="caption">
    <div class="flex align-items-center justify-content-end gap-1">
      <p-button *ngIf="mode == 'exportOffer'" label="{{'UserPages.UserExportOfferDocument.NewButtonLabel' | translate}}" icon="pi pi-plus" class="mr-2" (onClick)="openDocumentCreateDialog(documentFormDirective, documentFileUploader)"/>
      <p-button [style]="{'background-color': '#8c2b87'}" label="{{'UserPages.UserExportOfferDocument.AssignDocumentButton' | translate}}" icon="pi pi-plus" (onClick)="visibleExportOffer()" class="mr-2"/>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th><div class="flex justify-content-start align-items-start">{{'UserPages.UserExportOfferDocument.TypeHeader' | translate}}</div></th>
      <th><div style="width: 70%;" class="flex justify-content-center align-items-center">{{'UserPages.UserExportOfferDocument.StatusHeader' | translate}}</div></th>
      <th class="flex justify-content-start align-items-start">Acciones</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-type>
    <tr>
      <td>
        <div class="flex justify-content-start align-items-start">
          {{type | technicalDocumentTypeName}}
        </div>
      </td>
      <td>
        <div class="flex justify-content-center align-items-center" style="width: 70%;">
          <span [ngClass]="!statusDocumentType(type.id) ? 'no-load' : 'load' " class="status-text">{{!statusDocumentType(type.id) ? notLoadedText: loadedText}}</span>
        </div>
      </td>
      <td>
        <div class="flex justify-content-start align-items-start">
          <p-button [disabled]="!statusDocumentType(type.id)" icon="pi pi-eye" (click)="viewDocumentByType(type.id) ">
          </p-button>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-dialog [(visible)]="visibleTechnicalDocuments" header="Documentos" [resizable]="false" [modal]="true" [style]="{width: '50%'}">
    <p-table
      [loading]="loading"
      [value]="documentByTypes"
      [paginator]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 25, 50]"
      responsiveLayout="stack"
      [breakpoint]="'600px'">
      <ng-template pTemplate="header">
          <tr>
            <th><div class="flex justify-content-center align-items-center">{{'UserPages.UserExportOfferDocument.NameHeader' | translate}}</div></th>
            <th><div class="flex justify-content-center align-items-center">PDF</div></th>
            <th><div class="flex justify-content-center align-items-center">{{'UserPages.UserExportOfferDocument.TypeHeader' | translate}}</div></th>
            <th></th>
          </tr>
      </ng-template>
      <ng-template pTemplate="body" let-document>
          <tr>
            <td><div class="flex justify-content-center align-items-center">{{ document.name }}</div></td>
            <td>
              <div class="flex justify-content-center align-items-center">
                <p-button pTooltip="Document PDF" (onClick)="getExportOfferDocument(document.id)" icon="pi pi-file-pdf" styleClass="p-button-outlined"></p-button>
              </div>
            </td>
            <td><div class="flex justify-content-center align-items-center">{{ document.technicalDocumentType | technicalDocumentTypeName }}</div></td>
            <td>
              <div class="flex justify-content-end align-items-center gap-2">
                <p-button label="{{'UserPages.UserExportOfferDocument.EditButtonLabel' | translate}}" icon="pi pi-pencil" (onClick)="openDocumentEditDialog(document, documentFileUploader)" class="mr-2"/>
                <p-button [style]="{'background-color': '#EF4444'}" label="{{'UserPages.UserExportOfferDocument.DeleteButtonLabel' | translate}}" icon="pi pi-trash" (onClick)="onDeleteDocument(document)" class="mr-2"/>
              </div>
            </td>
          </tr>
      </ng-template>
    </p-table>
  </p-dialog>


<p-dialog header="{{'UserPages.UserExportOfferDocument.Form.Title' | translate}}" [(visible)]="documentDialogVisible" [style]="{width: '50%'}" [modal]="true">
  <form [formGroup]="documentFormGroup" #documentFormDirective="ngForm">
    <div class="p-fluid formgrid grid" style="padding: 20px;">
      <div class="field col-12 md:col-12 lg:col-12" style="margin-bottom: 40px;">
        <label for="name" style="font-weight: bolder;">{{'UserPages.UserExportOfferDocument.Form.NameLabel' | translate}} *</label>
        <input id="name" formControlName="name" type="text" required pInputText placeholder="{{'UserPages.UserExportOfferDocument.Form.NameLabel' | translate}}"/>
        <small *ngIf="submitDocument && documentFormGroup.controls['name'].invalid" class="p-error">{{getErrorMessage(documentFormGroup, 'name')}}</small>
      </div>
      <div class="field col-12 md:col-12 lg:col-12" style="margin-bottom: 40px;">
        <label for="name" style="font-weight: bolder;">{{'UserPages.UserExportOfferDocument.Form.TechnicalDocumentTypeLabel' | translate}} *</label>
        <p-dropdown [options]="technicalDocumentTypes"
        formControlName="technicalDocumentTypeId"
        optionLabel="name"
        placeholder="{{'UploadDocumentDialog.TypeDocumentPlaceholder' | translate}}"
        styleClass="mb-2" optionValue="id">
          <ng-template let-type  pTemplate="selectedItem">
              <div class="flex align-items-center gap-2">
                  <div>{{ type | technicalDocumentTypeName }}</div>
              </div>
          </ng-template>
          <ng-template let-type pTemplate="item">
            <div class="flex align-items-center gap-2">
                <div>{{ type | technicalDocumentTypeName }}</div>
            </div>
          </ng-template>
      </p-dropdown>
      </div>
      <div class="field col-12" style="margin-bottom: 40px;">
        <label>{{'UserPages.UserExportOfferDocument.Form.LoadDocumentLabel' | translate}}</label>
        <p-fileUpload
          #documentFileUploader
          (onSelect)="onSelectDocumentFile($event)"
          (onClear)="onClearDocumentFile($event)"
          [showUploadButton]="false"
          [multiple]="false"
          accept=".pdf"
          [maxFileSize]="5000000"
          chooseLabel="{{'UserPages.UserExportOfferDocument.Form.SelectFile' | translate}}"
          cancelLabel="{{'UserPages.UserExportOfferDocument.Form.CancelSelectFile' | translate}}"/>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <p-button label="{{'UserPages.UserExportOfferDocument.Form.BackButtonLabel' | translate}}" (onClick)="documentDialogVisible = false" styleClass="p-button-outlined"></p-button>
    <p-button label="{{'UserPages.UserExportOfferDocument.Form.SaveButtonLabel' | translate}}" (onClick)="saveDocument()" [loading]="loading"></p-button>
  </ng-template>
</p-dialog>

<p-dialog header="{{'UserPages.UserExportOfferDocument.DialogExportOfferTitle' | translate}}" [(visible)]="visibleAssignCertificate" [style]="{width: '50%'}" [modal]="true" *ngIf="exportOfferId || orderId">
  <app-upload-export-documents
  (OnSaveEvent)="getDocuments()"
  (OnCancelEvent)="closeDialog()"
  [exportOfferId]="exportOfferId"
  [orderId]="orderId"
  [mode]="mode"
  >
</app-upload-export-documents>
</p-dialog>


<p-confirmDialog acceptLabel="Yes" rejectLabel="No" rejectButtonStyleClass="p-button-outlined" [style]="{width: '50vw'}"></p-confirmDialog>
